<template>
    <div class="page-main">
        <div class="page-main-child">

            <!-- Left Side -->
            <div class="pmc-left-container">
                <div class="pmc-left">
                    <div class="dd-label flex items-center gap-2 font-mono text-white cursor-pointer"
                        @click="redirectToHomePage">
                        <DecastLogo />
                        <span class="ml-2">Decast</span>
                    </div>
                    <DidNetworkImage />
                    <div class="pmc-left-bottom">
                        <div class="plb-div">
                            <ThumbsUp />
                            <span>Freedom of</br>Speech​</span>
                        </div>
                        <div class="plb-div">
                            <ThumbsUp />
                            <span>Digital</br>Privacy​​</span>
                        </div>
                        <div class="plb-div">
                            <ThumbsUp />
                            <span>Data Protection</br>& Ethical use​​</span>
                        </div>
                        <div class="plb-div">
                            <ThumbsDown />
                            <span>Surveillance</br>Capitalism​</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Side -->
            <div class="pmc-right-container">
                <div class="pmc-right hide-scrollbar">
                    <a class="back-link cursor-pointer" @click="redirectToLoginPage">Back to Login</a>

                    <h1>What's a <span class="highlight">DecastID</span>?</h1>

                    <blockquote>
                        “No more passwords. No more platforms owning your identity.”
                    </blockquote>

                    <p class="description">
                        With DECAST.LIVE, you log in using your Decentralized Identifier (DID), a secure, private, and
                        user-controlled way to access the platform.
                    </p>

                    <ul class="features">
                        <li><strong>Own your identity</strong><br> You’re in control. Not big tech.</li>
                        <li><strong>Secure by design</strong><br> Built on cryptographic trust, not vulnerable
                            credentials.</li>
                        <li><strong>Portable and interoperable</strong><br> Use your DID across different platforms and
                            ecosystems.</li>
                    </ul>

                    <button class="login-btn login-did-btn" @click="handleDidsLogin">
                        <div class="did-icon-wrapper-btn">
                            <DidIcon />
                        </div> Login with a&nbsp;<span>DecastID</span>
                    </button>

                    <div class="flex items-center gap-2 text-gray-400 font-mono text-sm my-8">
                        <div class="sep-line flex-grow h-px"></div>
                        <div class="sep-line-label">OR</div>
                        <div class="sep-line flex-grow h-px"></div>
                    </div>

                    <div class="extension">
                        <p><strong>DecastID Extension</strong><br>Add our extension to your browser to create and manage
                            identities.</p>
                        <a class="chrome-badge cursor-pointer" @click="redirectToWebstore">
                            <ChromeExtensionCard />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { afterAuthPath } from '@/http/requests/billing';
// import { ref } from 'vue'
import LockImage from '@/decast/components/common/LockImage.vue';
import DecastLogo from '@/decast/icons/DecastLogo.vue';
import DidIcon from '../../icons/DidIcon.vue';
import DidNetworkImage from '../../components/common/DidNetworkImage.vue';
import ChromeExtensionCard from '../../components/common/ChromeExtensionCard.vue';
import constants from '../../../../constant';
import ThumbsUp from '../../icons/ThumbsUp.vue';
import ThumbsDown from '../../icons/ThumbsDown.vue';
const EXTENSION_ID = constants.didManagerExtensionKey;

export default {
    data() {
        return {
            isLoading: false,
            errorMessage: '',
            selectedDid: '',
            selectedUsername: '',
            boundNonceHandler: null,
        };
    },
    components: {
        LockImage,
        DecastLogo,
        DidIcon,
        DidNetworkImage,
        ChromeExtensionCard,
        ThumbsUp,
        ThumbsDown,
    },
    mounted() {
        document.getElementById('loading-bg-transparent').style.display = 'none';
        window.addEventListener('message', this.handleDidSelected);
    },
    beforeUnmount() {
        window.removeEventListener('message', this.handleDidSelected);
    },
    methods: {
        redirectToHomePage() {
            this.$router.push('/');
        },
        redirectToLoginPage() {
            this.$router.push('/v2login');
        },
        redirectToWebstore() {
            window.location.href = 'https://chrome.google.com/webstore/detail/decast-did-manager/' + EXTENSION_ID;
        },
        async handleDidsLogin() {
            this.isLoading = true;
            this.errorMessage = '';

            if (window.chrome && chrome.runtime) {
                chrome.runtime.sendMessage(
                    EXTENSION_ID,
                    { action: 'open-did-popup' },
                    (response) => {
                        if (chrome.runtime.lastError) {
                            this.isLoading = false;
                            this.errorMessage = 'Extension not available';
                        }
                    }
                );

                window.addEventListener('message', this.handleDidSelected);
            } else {
                this.isLoading = false;
                this.errorMessage = 'Extension API not available';
                this.$vs.notify({
                    title: 'Request Unsuccessful',
                    text: 'Extension not installed or not available',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'danger',
                });
                window.location.href = 'https://chrome.google.com/webstore/detail/decast-did-manager/' + EXTENSION_ID;
                
            }
        },
        async handleDidSelected(event) {
            if (event.data?.action !== 'did-selected') return;

            window.removeEventListener('message', this.handleDidSelected);

            try {
                const { did, username } = event.data;
                // Handle both string and object formats from extension (for backwards compatibility)
                if (typeof did === 'string') {
                    this.selectedDid = did;
                    this.selectedUsername = username || '';
                } else {
                    this.selectedDid = did?.did || '';
                    this.selectedUsername = did?.username || username || '';
                }
                console.log("[Decast] DID selected:", this.selectedDid, "Username:", this.selectedUsername);

                const payload = { did: this.selectedDid };
                this.$store
                    .dispatch('auth/v2getDidNonce', payload)
                    .then((response) => {
                        const { nonce, token } = response.data;
                        // console.log("[Decast] Nonce received from API:", nonce);
                        chrome.runtime.sendMessage(
                            EXTENSION_ID,
                            { action: "sign-nonce", nonce, did },
                            (response) => {
                                if (chrome.runtime.lastError) {
                                    this.errorMessage = 'Error communicating with extension';
                                } else {
                                    this.$vs.notify({
                                        title: 'Success',
                                        text: 'Nonce sent to extension for signing',
                                        iconPack: 'feather',
                                        icon: 'icon-check-circle',
                                        color: 'success',
                                    });
                                    // console.log("[Decast] Nonce sent to extension for signing");
                                }
                            }
                        );

                        // Store bound handler so we can remove it later
                        this.boundNonceHandler = (e) => this.handleNonceSigned(e, token);
                        window.addEventListener('message', this.boundNonceHandler);
                    })
                    .catch((error) => {
                        // Safely extract the specific error message
                        const errorResponse = error.response?.data;
                        let message = "An error occurred.";
                        if (errorResponse?.errors?.email) {
                            message = "Account does not exist!";
                        } else if (typeof errorResponse?.errors === 'string') {
                            message = errorResponse.errors;
                        }
                        this.$vs.notify({
                            title: 'Login Failed',
                            text: message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger',
                        });
                    }).finally(() => { });
            } catch (err) {
                this.isLoading = false;
                this.errorMessage = err.message;
            }
        },
        async handleNonceSigned(event, token) {
            // console.log("[Decast] Handling nonce signed event");
            // console.log("[Decast] Event data:", event.data, event.data?.action);
            if (event.data?.action !== 'nonce-signed') return;

            // Remove the bound handler we stored earlier
            if (this.boundNonceHandler) {
                window.removeEventListener('message', this.boundNonceHandler);
                this.boundNonceHandler = null;
            }

            if (event.data.error) {
                this.$vs.notify({
                    title: 'Nonce Signing Canceled',
                    text: event.data.error,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'warning',
                });
                this.isLoading = false;
                this.errorMessage = event.data.error;
                return;
            }

            this.$vs.notify({
                title: 'Success',
                text: 'Nonce signed successfully',
                iconPack: 'feather',
                icon: 'icon-check-circle',
                color: 'success',
            });

            const { signature } = event.data;
            console.log("[Decast] Nonce signed by extension:", signature);

            try {
                console.log("[Decast] Preparing DID Document for login");

                const didDocument = {
                    '@context': 'https://www.w3.org/ns/did/v1',
                    id: this.selectedDid,
                    verificationMethod: [{
                        id: `${this.selectedDid}#keys-1`,
                        type: 'Ed25519VerificationKey2018',
                        controller: this.selectedDid,
                        publicKeyBase58: this.selectedDid.split(':').pop(),
                    }],
                    authentication: [`${this.selectedDid}#keys-1`],
                };

                console.log("[Decast] DID Document prepared2:", didDocument);

                const payload = {
                    token,
                    signature,
                    didDocument,
                    username: this.selectedUsername || undefined,
                };
                console.log("[Decast] Dispatching v2loginWithDid with payload:", payload);
                this.$store.dispatch('auth/v2loginWithDid', payload)
                    .then((response) => {
                        console.log("[Decast] Login response:", response.data);
                        const isTwoFactorAuthEnabled = response.data?.twoFactorAuthentication;
                        if (isTwoFactorAuthEnabled) {
                            // ask for 2fa
                            const twoFactorToken = response.data?.token;
                            this.$router.push({ name: 'TwoFactor', query: { tempToken: twoFactorToken } });
                        } else {
                            this.$store.commit('auth/SET_LOGGEDIN', true);
                            this.$acl.change('user');
                            this.$vs.notify({
                                title: 'Login Successful',
                                text: 'Redirecting to dashboard!',
                                iconPack: 'feather',
                                icon: 'icon-check-circle',
                                color: 'success',
                            });
                            this.$router.push(afterAuthPath('/dashboard/rooms'));
                        }
                    })
                    .catch((error) => {

                        console.log(error, 'login error');
                        this.$vs.notify({
                            title: 'Login Failed',
                            text: error,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger',
                        });
                    }).finally(() => {
                        this.isLoading = false;
                        document.getElementById('loading-bg-transparent').style.display = 'none';
                    });
            } catch (err) {
                this.errorMessage = err.message;
                this.isLoading = false;
            }
        },
    }
}
</script>

<style scoped>
*:not(i) {
    font-family: 'Rethink Sans' !important;
}

.hide-scrollbar {
    scroll-behavior: smooth;
    overflow: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE and Edge */
}

.hide-scrollbar::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari, Opera */
}

.page-main {
    height: 100vh;
    width: 100vw;
}

.page-main-child {
    height: 100vh;
    width: 100vw;
    display: flex;
    overflow: hidden;
}

.pmc-left-container {
    width: 50%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #1B1D29;
}

.pmc-left {
    width: 100%;
    height: 100%;
    padding: 30px 70px;
    display: flex;
    flex-direction: column;
}

.pmc-left svg {
    width: auto;
    height: auto;
}

.pmc-left span {
    font-size: 18px;
    font-weight: 500;
}

.pmc-right-container {
    width: 50%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #15161F;
}

.pmc-right h1 {
    color: #FFFFFF;
    font-size: 40px;
    line-height: 120%;
}

.pmc-left-bottom {
    display: flex;
    justify-content: space-between;
}

.pmc-left-bottom .plb-div {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
}

.pmc-left-bottom .plb-div span {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
}

.pmc-left-bottom svg {
    width: 40px;
    height: 40px;
    opacity: 0.8;
}

/* Animation: slide-fade */
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s ease;
    position: absolute;
    width: 100%;
}

.slide-fade-enter-from {
    transform: translateX(100%);
    opacity: 0;
}

.slide-fade-leave-to {
    transform: translateX(-100%);
    opacity: 0;
}

.slide-fade-enter-to,
.slide-fade-leave-from {
    transform: translateX(0%);
    opacity: 1;
}

.pmc-right {
    position: relative;
    overflow: hidden;
    width: 80%;
    height: 100%;
    padding: 70px 70px 0px 70px;
    overflow-y: scroll;
}

.back-link {
    color: #c7ff57;
    text-decoration: none;
    font-size: 14px;
    margin-bottom: 20px;
    display: inline-block;
    border-bottom: 1px solid transparent;
}

.back-link:hover {
    border-bottom: 1px solid #c7ff57;
}

.highlight {
    color: #c7ff57;
}

blockquote {
    font-size: 20px;
    font-style: italic;
    color: #DDDDDD;
    margin: 20px 0;
    font-weight: 700;
}

.description {
    font-size: 14px;
    color: #B3B3B3;
    margin-bottom: 20px;
}

.features {
    list-style: none;
    padding: 0;
    margin-bottom: 30px;
}

.features li {
    margin-bottom: 15px;
    font-size: 14px;
    color: #B3B3B3;
}

.features li strong {
    color: #FFFFFF;
}

.login-button {
    background-color: transparent;
    color: #fff;
    border: 1px solid #444;
    padding: 12px 16px;
    font-size: 16px;
    border-radius: 10px;
    width: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.3s ease;
}

.login-button:hover {
    background-color: #1a1a1a;
    border-color: #c7ff57;
}

.divider {
    text-align: center;
    margin: 30px 0 20px;
    color: #666;
    font-size: 12px;
}

.extension {
    font-size: 14px;
    color: #B3B3B3;
    display: flex;
    align-items: center;
}

.extension strong {
    color: #c7ff57;
}

.extension a {
    display: flex;
}

.extension a img {
    width: 54px;
    height: 54px;
}

.chrome-badge img {
    margin-top: 10px;
    width: 160px;
}

.login-btn {
    font-size: 14px;
    border-radius: 10px;
    color: #FFFFFF;
    padding: 0rem 0.85rem;
    width: 100%;
    height: 46px !important;
    outline: none;
    border: 1px solid #FFFFFF40;
    cursor: pointer;
    transition: transform 0.05s ease-in-out;
    position: relative;
    background-color: #15161F;
    display: flex;
    align-items: center;
    justify-content: center;
}

.login-did-btn {
    border: 1px solid #FFFFFF;
}

.login-did-btn span {
    color: #D7DF23;
}

.did-icon-wrapper-btn {
    background-color: #1B1D29 !important;
    border: 1px solid #242632 !important;
    border-radius: 4px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    width: min-content;
    padding: 5px;
    margin-right: 8px;
}

.did-icon-wrapper-btn svg {
    height: 12px;
    width: 12px;
}

.sep-line {
    background-color: #444551;
    opacity: 0.5;
}

.sep-line-label {
    color: #FFFFFF50;
    background-color: #1B1D29;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
}

/* Animation: slide-fade end*/

@media (max-width: 1024px) {
    .pmc-right {
        width: 100%;
        padding: 70px 40px;
    }
}

@media (max-width: 768px) {
    .pmc-left-container {
        display: none;
    }

    .pmc-right-container {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .pmc-right {
        padding: 20px;
    }
}
</style>
